import React, {Component} from 'react'
import { cashRegisterMap } from '../cashRegister/cashRegisterInfo'

class KeyRightColumn extends Component {
  render() {
    return <div className="tile is-12 is-child box">
      <p><strong>Описание модели ККТ и Рекомендации:</strong></p>
      <p>Описание и характеристики ККТ:</p>
      <img src={ cashRegisterMap.get(this.props.register).image } alt={ cashRegisterMap.get(this.props.register).name }/>
      <ul dangerouslySetInnerHTML={{__html: cashRegisterMap.get(this.props.register).info}}></ul>
      <p>При выборе ККТ обратите внимание на:</p>
      <ul>
        <li>ширину ленты</li>
        <li>наличие автоотрезчика</li>
        <li>скорость печати чека и QR-кода</li> 
        <li>Способы подключения к Интернет</li>
      </ul>
      <p>Рекомендации:</p>
      <ul>
        <li>Большой поток клиентов (супермаркет, столовая, аптека и т.д.) – берите с автоотрезчиком и высокой скоростью печати</li>
        <li>Для офиса или салона (бутика) достаточно регистратора с шириной ленты 44-57 мм без автоотрезчика</li>
        <li>Печатаете на чеке гарантию, промо-акции, рекламу – выбирайте модель с шириной ленты 80 мм</li>
        <li>Пит-Стоп в «поле» (нет возможности провести кабельный Интернет) – выбирайте модель с USB-модемом</li>
      </ul>      
    </div>
  }
}

export default KeyRightColumn


// WEBPACK FOOTER //
// ./src/components/ofdCalc/rightColumn/KeyRightColumn.js